import classNames from './GoogleDeleteClassConfirmationModal.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';
import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';
import AppLoaderCircle from '../AppLoaderCircle';
import { SyncGoogleCourses } from '@/types/register';
import errorIcon from '@/assets/svg/error.svg';
import SVG from 'react-inlinesvg';

interface GoogleDeleteClassConfirmationModalProps {
  show: boolean;
  hasFilteredClasses: boolean;
  isForced: boolean;
  isLoading: boolean;
  googleClassesDelete: SyncGoogleCourses[];
  onSubmit: () => void;
  onCancel: () => void;
}

const GoogleDeleteClassConfirmationModal = ({
  show,
  googleClassesDelete,
  isForced,
  isLoading,
  onSubmit,
  onCancel,
}: GoogleDeleteClassConfirmationModalProps) => {
  const { t } = useTranslation();

  const firstDeleteClass = googleClassesDelete.find(classItem => classItem.action === 'delete');

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            <AppBackdrop className={classes(classNames.backdrop, `backdrop-${state}`)} />
            <AppModal className={classNames.appModal}>
              <div className={classes(classNames.modal, `fade-${state}`)}>
                {isForced && <SVG src={errorIcon} className={classNames.icon} />}
                <h2>
                  {isForced
                    ? t('classWasDeleted', {
                        className: firstDeleteClass?.name,
                      })
                    : t('areYouSure')}
                </h2>
                <span className={classNames.description}>
                  {isForced ? t('classWasDeletedDescription') : t('deleteClassesAttention')}
                </span>
                {isLoading ? (
                  <AppLoaderCircle className='m-auto' />
                ) : (
                  <>
                    <TheButton
                      className={classNames.deleteBtn}
                      text={t('yesDelete')}
                      shouldRecolor={false}
                      emitOnClick={onSubmit}
                    />
                    {!isForced && (
                      <TheButton
                        className={classNames.closeBtn}
                        text={t('cancel')}
                        plain={true}
                        shouldRecolor={false}
                        emitOnClick={onCancel}
                      />
                    )}
                  </>
                )}
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default GoogleDeleteClassConfirmationModal;
